// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_9a_","cls2":"Comments-cls2_KNK Comments-cls1_9a_"};